/**
 * TK-43 — BỘ CHUYỂN icon menu: một kiểu chung cho mọi chỗ nhận icon (`<n.icon strokeWidth className />`), dùng được cả icon SDKD
 *   lẫn lucide (mục khác vẫn lucide). Hình học nằm ở `SdkdIcon.tsx` (chép nguyên từ bộ icon SDKD v01 — KHÔNG sửa hình ở đây).
 *   Màu: `currentColor` ⇒ ăn màu chữ chỗ đặt (`chu-2`, chọn ⇒ `nhan`). KHÔNG dùng màu neon của bộ icon, không glow.
 */
import type { ComponentType } from 'react';
import { SdkdIcon, type SdkdIconName } from './SdkdIcon';

/** `strokeWidth` nhận cả chuỗi như lucide (`LucideProps`) — để lucide gán được vào kiểu chung mà không ép kiểu */
export interface IconMenuProps { className?: string; strokeWidth?: number | string }
/** Kiểu chung của icon một mục menu — lucide (`LucideIcon`) cũng gán được vào đây, không ép kiểu. */
export type IconMenu = ComponentType<IconMenuProps>;

function iconSdkd(name: SdkdIconName): IconMenu {
  const C = ({ className, strokeWidth }: IconMenuProps) => <SdkdIcon name={name} className={className} strokeWidth={strokeWidth} />;
  C.displayName = `SdkdIcon(${name})`;
  return C;
}

/* 8 mục menu ⇐ bộ SDKD v01 (bảng phiếu TK-43 mục 1) */
export const IconVanHanh = iconSdkd('van-hanh');
export const IconChienLuoc = iconSdkd('chien-luoc');
export const IconNangLuong = iconSdkd('nang-luong');
export const IconNhatKy = iconSdkd('nhat-ky');
export const IconQuanLyTu = iconSdkd('quan-ly-tu');
export const IconQuanLyDen = iconSdkd('quan-ly-den');
export const IconCaiDatBanDau = iconSdkd('cai-dat-ban-dau');
export const IconQuanTri = iconSdkd('quan-tri');
